import * as React from "react";
import type { SVGProps } from "react";
const SvgKidsPlaygroundIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#kids-playground-icon_svg__a)">
      <path
        fill="#858585"
        d="M6.09-.002a.56.56 0 0 0-.333.158L.244 5.686a.53.53 0 0 0-.245.42.6.6 0 0 0 0 .122V27.44c0 .308.252.56.56.56h1.68c.309 0 .56-.252.56-.56v-9.52h6.72v1.12H3.36v1.12h6.16v1.12H3.36v1.12h6.16v1.12H3.36v1.12h6.16v1.12H3.36v1.12h6.16v.56c0 .308.252.56.56.56h1.68c.309 0 .56-.252.56-.56v-9.993a1 1 0 0 0 0-.088V6.246a1 1 0 0 0 0-.088v-.087L12.302 6q-.015-.045-.035-.088l-.018-.017a1 1 0 0 0-.07-.105v-.018l-.017-.017h-.018a.3.3 0 0 0-.035-.035L6.562.156a.56.56 0 0 0-.473-.158m.07 1.365 4.234 4.235h-8.47zM1.12 6.718H11.2v10.08H1.12zm5.04 1.12a3.936 3.936 0 0 0-3.92 3.92 3.936 3.936 0 0 0 3.92 3.92 3.936 3.936 0 0 0 3.92-3.92 3.936 3.936 0 0 0-3.92-3.92m0 1.12c1.541 0 2.8 1.258 2.8 2.8 0 1.543-1.259 2.8-2.8 2.8a2.805 2.805 0 0 1-2.8-2.8c0-1.542 1.257-2.8 2.8-2.8m6.72 2.24v1.12c2.092 0 3.285.698 4.182 1.768.896 1.07 1.454 2.566 1.995 4.13.54 1.564 1.07 3.178 2.047 4.462s2.468 2.188 4.655 2.188c.602 0 1.12.61 1.12 1.277v.683c-3.089-.074-5.222-.63-6.615-1.453-1.492-.879-2.281-2.019-2.852-3.22-.571-1.2-.882-2.44-1.453-3.482-.57-1.041-1.549-1.872-3.08-1.872v1.12c1.186 0 1.619.428 2.083 1.277.463.849.809 2.128 1.435 3.447.625 1.32 1.577 2.7 3.29 3.71 1.712 1.011 4.158 1.645 7.752 1.645.308 0 .56-.251.56-.56v-1.294c0-1.239-.936-2.398-2.24-2.398-1.9 0-2.949-.682-3.762-1.75-.814-1.067-1.328-2.575-1.873-4.147s-1.129-3.214-2.205-4.498-2.682-2.153-5.04-2.153m-11.76 6.72h.56v8.96h-.56zm9.52 0h.56v8.96h-.56z"
      />
    </g>
    <defs>
      <clipPath id="kids-playground-icon_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKidsPlaygroundIcon;
